import axios from "axios";
import store from "./redux/store";
import { logOut } from "./redux/auth/authSlice";

const apiCall = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

apiCall.interceptors.request.use(
  (req) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.token) {
      if (Date.now() > new Date(user.expireIn).getTime()) {
        store.dispatch(logOut());
        throw new axios.Cancel("Session expired");
      }
      req.headers.Authorization = `Bearer ${user.token}`;
    }
    return req;
  },
  (error) => Promise.reject(error)
);

export default apiCall;
